<form
  class="d-flex flex-column gap-2"
  [formGroup]="form"
  [ngClass]="{ 'was-validated': validated }"
>
  <ng-container formArrayName="timeShiftsForm">
    <div class="row d-none d-sm-flex justify-content-end">
      <div class="col-3">
        <div>{{ 'externalEmployees.timeRecordings.begin' | translate }}</div>
      </div>
      <div class="col-3">
        <div>{{ 'end' | translate }}</div>
      </div>
    </div>
    <div
      *ngFor="let shift of timeShiftsForm.controls; let i = index"
      [formGroupName]="i"
      class="shift-time-row"
    >
      <div class="shift-type-legend">
        <i
          class="fa-regular"
          [ngClass]="baseShiftIconsEnum[shift.getRawValue().type]"
        ></i
        ><span>{{
          'externalEmployees.masterData.shiftReadiness.' + shift.value.type | baseBusinessKey | translate
        }}</span>
      </div>
      <div class="shift-times">
        <input
          formControlName="startTime"
          type="time"
          class="administration-shift-time-field"
          [ngClass]="{ invalid: timeShiftsForm.controls[i].invalid }"
          #startTimeInput
        />
        <input
          formControlName="endTime"
          type="time"
          class="administration-shift-time-field"
        />
      </div>
    </div>
  </ng-container>
</form>

<div class="d-flex justify-content-between modal-footer py-4 px-0">
  <base-button
    (btnClick)="closeModal()"
    color="secondary"
    label="action.cancel"
  ></base-button>
  <base-button
    (btnClick)="saveTimeShifts()"
    color="primary"
    label="action.save"
  ></base-button>
</div>
